var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogoXs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 3.14975L2.26012 0.724309C1.8206 0.538607 1.33398 0.861271 1.33398 1.33841V11.6663C1.33398 12.0345 1.63246 12.333 2.00065 12.333H14.0007C14.3688 12.333 14.6673 12.0345 14.6673 11.6663V3.5918C14.6673 3.32388 14.5069 3.08198 14.2601 2.9777L8.92678 0.724309C8.48726 0.538607 8.00065 0.861271 8.00065 1.33841V3.14975ZM8.00065 3.14975V5.26446M3.55621 9.333H4.66732M5.77843 9.333H6.88954",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.06667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoXs);
export default __webpack_public_path__ + "static/media/company-logo-xs.7141f87eca1e08017d275c8bdd2ffc61.svg";
export { ForwardRef as ReactComponent };